import {Component, OnInit, Input, EventEmitter, Output} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {State} from 'app/e-form/model/eform-type';
import {EFormHelper} from 'app/e-form/helper/script/helper';
import {ErorsMessage} from 'app/e-form/helper/script/error-message';
import {TranslateService} from '@ngx-translate/core';
import {EformAPI} from '../../../e-form.api';
import {DecimalPipe} from '@angular/common';
import { Observable } from 'rxjs';

@Component({
   selector: 'app-number-properties',
   templateUrl: './number-properties.component.html',
   styleUrls: ['./number-properties.component.scss'],
   providers: [DecimalPipe]
})
export class NumberPropertiesComponent implements OnInit {
   @Input() eForm: FormGroup;
   @Input() state: State;
   @Input() table: any;
   @Output() sendFocus = new EventEmitter<boolean>();
   helper = new EFormHelper();
   errMsg = new ErorsMessage(this.translate);
   type: string;
   deicmalPlace = [];
   displayDisabled: boolean;
   @Input() eventsStateChild: Observable<void>;
   number: any;
   decimal: number;
   startMaxLength: number;
   endMaxLength: number;


   constructor(public translate: TranslateService, private api: EformAPI, private _decimalPipe: DecimalPipe) {
   }

   ngOnInit(): void {
      this.startMaxLength = 15;
      this.endMaxLength = 15;
      this.onSetUpDecimalPalce();
      this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      this.helper.displayDisabledChanges.subscribe((value) => {
         this.displayDisabled = value;
      });
      this.eventsStateChild.subscribe(() => {
         this.helper.checkDisplayDisabled(this.eForm, this.state, this.table);
      });
   }

   onSetUpDecimalPalce() {
      this.api.getConfigDecimalPlace().subscribe(res => {
         for (let i = 0; i <= res; i++) {
            const _tmp = {display: i, value: i};
            this.deicmalPlace.push(_tmp);
         }
      }, err => {
         console.error(err);
      });
      if (!this.getDecimalPlaceControl.value) {
         this.getDecimalPlaceControl.patchValue(0);
      }
   }

   onClickInteger($event: any) {
      this.getDecimalPlaceControl.patchValue(0);
      this.table ? this.getFieldTable.updateValueAndValidity() : this.getField.updateValueAndValidity();
   }

   updateRange() {
      setTimeout(() => {
         if (this.table) {
            this.getFieldTable.get('rangeStart').updateValueAndValidity();
            this.getFieldTable.get('rangeEnd').updateValueAndValidity();
         } else {
            this.getField.get('rangeStart').updateValueAndValidity();
            this.getField.get('rangeEnd').updateValueAndValidity();
         }
      }, 500);
   }

   _updateRange(type: string, v: string) {
      const _s = v.replace(/,/g, '');
      const _gobalFloat = parseFloat(_s);
      if (_s.startsWith('-')) {
         const _float = parseFloat(_s.substring(1));
         if (Math.round(_float * 100000) === 0) {
            if (this.table) {
               this.getFieldTable.get(type).patchValue('0');
            } else {
               this.getField.get(type).patchValue('0');
            }
         } else if (!_s.endsWith('-')) {
            if (isNaN(+_s)) {
               if (this.table) {
                  this.getFieldTable.get(type).patchValue('0');
               } else {
                  this.getField.get(type).patchValue('0');
               }
            } else {
               let _string = '';
               if (_s.length === 15 && _s.indexOf('.') === 1) {
                  _string = _float.toFixed(12).toString();
               } else {
                  _string = _float.toString();
               }
               if (this.table) {
                  this.getFieldTable.get(type).patchValue('-' + _string, {emitEvent: false, emitModelToViewChange: false});
               } else {
                  this.getField.get(type).patchValue('-' + _string, {emitEvent: false, emitModelToViewChange: false});

               }
            }
         }
      } else if (Math.round(_gobalFloat * 100000) === 0) {
         if (this.table) {
            this.getFieldTable.get(type).patchValue('0');
         } else {
            this.getField.get(type).patchValue('0');
         }
      } else if (_s) {
         const _int = +_s;
         let _value = '';
         if (_s.length === 15 && _s.startsWith('.')) {
            _value = isNaN(_int) ? '0' : _int.toFixed(13).toString();
         } else {
            _value = isNaN(_int) ? '0' : _int.toString();
         }
         if (this.table) {
            this.getFieldTable.get(type).patchValue(_value, {emitEvent: false, emitModelToViewChange: false});
         } else {
            this.getField.get(type).patchValue(_value, {emitEvent: false, emitModelToViewChange: false});
         }
      }
   }

   onFocus(type: string, value: string) {
      if (type === 'rangeStart') {
         this.startMaxLength = 15;
      } else {
         this.endMaxLength = 15;
      }
      value = value.replace(/ /g,'');
      value = value.replace(/,/g, '');
      this.getField?.get(type)?.setValue(value);
   }

   onBlur(type: string, value: string) {
      value = value.replace(/\s/g, '');
      value = value.replace(/,/g, '');
      value = value.replace(/ /g,'');
      if (value.indexOf('.') === -1) {
         this.number = value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
         this.number = + value;
         if (isNaN(this.number)) {
            this.number = value;
         } else {
            const splNumber = this.number.toString().split('.')[0];
            const splDecimal = this.number.toString().split('.')[1];
            if (splDecimal) {
               this.number = splNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + splDecimal;
            } else {
               this.number = splNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            }
         }
      }
      let invalid = this.getField?.get(type)?.status === 'INVALID';
      this.getField?.get(type)?.setValue(Number(this.number) === 0 ? '':this.number);
      let count = 0 | this.number.match(/\,/g)?.length;
      if (type === 'rangeStart') {
         this.startMaxLength += count;
      } else {
         this.endMaxLength += count;
      }
      if (!invalid) {
         this.getField?.get(type)?.setErrors(null);
      }
   }

   getFieldWithRgx(type: string) {
      if (this.table) {
         const x = this.getFieldTable.get(type).value;
         return x.replace(/,/g, '');
      } else {
         const x = this.getField.get(type).value;
         return x.replace(/,/g, '');

      }
   }

   getDecimalPlace(): number {
      let f = this.getField.get('decimalPlace');
      return f?.value ? f.value : 0;
   }

   changeDecimalPlace(decimal) {
      switch (decimal) {
         case 1: {
            this.decimal = 10;
            break;
         }
         case 2: {
            this.decimal = 100;
            break;
         }
         case 3: {
            this.decimal = 1000;
            break;
         }
         case 4: {
            this.decimal = 10000;
            break;
         }
         case 5: {
            this.decimal = 100000;
            break;
         }
         default: {
            this.decimal = 1;
            break;
         }
      }
   }

   isNanValue(value) {
      return isNaN(value);
   }

   sendFocusToCreate(focus: boolean) {
      this.sendFocus.emit(focus);
   }

   get _rangeMustValue() {
      return this.getField.value.rangeEnd !== undefined || this.getField.value.rangeStart !== undefined;
   }

   get getField() {
      return this.helper.getFieldAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex);
   }

   get getFieldTable() {
      return this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex);
   }

   get getDecimalPlaceControl() {
      return this.table ? this.getFieldTable.get('decimalPlace') : this.getField.get('decimalPlace');
   }

   _setOption(value: any, type: string) {
      this.helper.getFieldTableAsFormGroupWithIndex(this.eForm, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex).get(type).setValue(value);
      this.helper.getFieldTableAsFormArray(this.eForm, this.state.sectionIndex, this.state.fieldIndex).updateValueAndValidity();
   }

   _getValue(type: string) {
      return this.helper.getFieldTableSomeValue(this.eForm, type, this.state.sectionIndex, this.state.fieldIndex, this.state.tableIndex);
   }
}
